import { Auth } from '@ax/auth';
import { clearVisitDetails, setSelectedDate, useAppDispatch, userSignedOut } from '@ax/redux-store';
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useLogout } from './api';
import { recordingState } from '@/store/recordingState';

export function useInactivityTimeout(timeoutMinutes: number) {
  const [isTimedOut, setIsTimedOut] = useState(false);
  const dispatch = useAppDispatch();
  const { mutateAsync: logout } = useLogout();

  const timeout = timeoutMinutes * 60 * 1000;

  const onIdle = async () => {
    if (!recordingState?.value?.recordingInprogress) {
      await logout({ logoutType: 'General' });
      Auth.logout();
      if (!Auth.isLoggedIn()) {
        dispatch(setSelectedDate({ date: '' }));
        dispatch(clearVisitDetails());
        dispatch(userSignedOut());
        setIsTimedOut(true);
      }
    }
  };

  const onActive = () => {
    setIsTimedOut(false);
  };

  useIdleTimer({
    onIdle: () => {
      onIdle().catch(console.error);
    },
    onActive,
    throttle: 500,
    startOnMount: timeout > 0,
    ...(timeout > 0 && { timeout }),
  });

  return { isTimedOut };
}
